module.exports = __webpack_public_path__ + "static/img/clearing_04.49780b89.svg";